<template>
    <div>
        <slot name="before"/>

        <form class="form avp-form form-finishorder" role="form" @submit.prevent="onSubmit" autocomplete="off">
            <div class="row mt-3">
                <div class="col-12 col-xs-12 col-sm-7">
                    <div class="form-row">
                        <div class="col-12">
                            <div class="form-group">
                                <input type="text" name="firstname" id="firstname" class="form-control"
                                       required="required"
                                       :placeholder="$t('generic.firstname')" maxlength="80" v-model="firstname"/>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group">
                                <input type="text" name="lastname" id="lastname" class="form-control"
                                       required="required"
                                       :placeholder="$t('generic.lastname')" maxlength="80" v-model="lastname"/>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group">
                                <input type="email" name="emailAddress" id="email" class="form-control"
                                       required="required"
                                       :placeholder="$t('generic.email')" v-model="email" maxlength="200"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-xs-12 col-sm-5">
                    <div class="total">
                        <label class="label-finishorder">{{ $t('bookingService.order_mode.total') }}</label>
                        <h2 class="text-right mb-0">0,00 €</h2>
                        <div class="text-right">
                            <TickIcon class="icon-tick pr-1"/>
                            {{ $t('bookingService.order_mode.already_paid') }}
                        </div>
                    </div>
                    <div class="text-center just">
                        <button type="submit" class="btn btn-primary btn-finishorder py-3 mt-2" :disabled="isSending">
                            {{ submitText }}
                        </button>
                    </div>
                </div>
            </div>


        </form>

        <slot name="after"/>
    </div>
</template>

<script>
import TickIcon from "../../../animod-shop-ssr/src/assets/icons/tick.svg";

export default {
    name: 'FinishOrderForm',
    components: {TickIcon},
    data() {
        return {
            firstname: '',
            lastname: '',
            email: '',
            phone: undefined,
        }
    },
    props: {
        submitText: {
            type: String,
            default() {
                return this.$t('bookingService.order_mode.button.submit')
            }
        },
        isSending: Boolean
    },
    computed: {},
    methods: {
        onSubmit() {
            const {firstname, lastname, email} = this;
            this.$emit('submit', {
                firstname,
                lastname,
                email
            })
        }
    }
}
</script>
<style>
.btn-finishorder {
    width: 100%;
}

.form-finishorder {
    border-top: 1px solid #CCC;
}

.label-finishorder {
    color: #999;
    text-transform: uppercase;
    font-size: 10px;
    line-height: 10px;
}

.icon-tick {
    fill: hsl(124, 97%, 54%);
    width: 1.5em;
    height: $line-height;
    position: relative;
    top: 0;
}
</style>
